// transfers
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import WebbSpinner from "../webb/webb-spinner-sm";
import WebbSpinText from "../webb/webb-spintext";
import ListNoData from "../webb/list-nodata";

import DataTable from "react-data-table-component";

import { GetTransfersList, GetTransfersCount } from "../../services/srvc-transfers-realm";

const code = require('../../data/code-transfers-stat.json').data;
const mode = require('../../data/code-transfers-mode.json').data;

const columns = [
  { 
    name: 'S', selector: 'stat', width:'3%',
    cell: row => 
    <div className={``}>
      <span className={`small bg-lite p-1 px-2 rounded d-none`}>
        <i className='bi-hexagon-fill text-tone'></i>
      </span>
      <span className={`text-${code.find(item=>parseInt(item.code)===row.stat).colr}`}>
        <i className={code.find(item=>parseInt(item.code)===row.stat).icon}></i>
      </span>
    </div>
  },
  { 
    name: 'Transaction', selector: 'trxn', width:'20%',
    cell: row => 
    <div className={``}>
      <span className="text-sm">{row.trxn}</span>
    </div>
  },
  { name: 'Method', selector: 'form', width:'10%',
    cell: row => 
    <div className={`rounded p-1 px-2 small bg-${mode.find(item=>parseInt(item.code)===row.form).colr}`}>
      <small className="text-white m-0 small">{mode.find(item=>parseInt(item.code)===row.form).text}</small>
    </div>
  },
  { 
    name: 'Date (UTC)', selector: 'crts', sortable: true, width:'15%',
    format: row => <div>
      {(new Date(row.crts)).toISOString().substring(0,10)}{', '}
      {(new Date(row.crts)).toISOString().substring(11,5)}
      </div> },
  { 
    name: 'From', selector: 'debt', sortable: false, width:'15%',
    cell: row => 
    <div className={``}>
      <span className="text-sm">{row.debt}</span>
    </div>
  },
  { 
    name: 'To', selector: 'cred', sortable: false, width:'15%',
    cell: row => 
    <div className={``}>
      <span className="text-sm">{row.cred}</span>
    </div>
  },
  { 
    name: 'Value', selector: 'amnt', sortable: false, width:'10%', right: true,
    cell: row => `${row.amnt}`,
  },
  { 
    name: 'Fee', selector: 'amft', sortable: false, width:'9%', right: true,
    cell: row => `${row.amft}`,
  },
  { 
    name: 'NT', selector: 'stat', width:'3%',
    cell: row => 
    <div className={`bg-lite rounded-circle text-center`}>
      <span className={``}><small>M</small></span>
    </div>
  },
];

const customStyles = {
  rows: {
    style: {
      backgroundColor: 'white',
    }
  },
  headCells: {
    style: {
      backgroundColor: 'white',
      fontWeight: 'bold'
    },
  },
  cells: {
    style: {
    },
  },
};

export default function TransfersListModule() {

  const asset = true
  const [loading, setLoading] = useState(false);

  const [item, setItems] = useState(10); // rows per page
  const [rows, setRows] = useState(0); // total rows
  const [cntr, setCounter] = useState(1); // current page counter
  const [live, setLive] = useState(false); // live stream

  const [data, setData] = useState([]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        
        setRows ((await GetTransfersCount()).data)
        
      }
      fetchData()
    } else {}
  },[asset]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        
        setLoading(true);
        
        setData ((await GetTransfersList(({
          data: {item: item, cntr: cntr},
          user: asset.usid
        }))).data)
        
        setLoading(false);
      }
      fetchData()
    } else {}
  },[asset, cntr, item]);


  const handleItem = items => {
    setItems(items)
  }


  const handleCounter = counter => {
    setCounter(counter)
  }


  if (loading){ return ( <> <div className="text-center"><WebbSpinner /></div> </> ) }
  if (!data || data.length === 0) { return ( <> <ListNoData/> </> ) }

  return (
  <>
    <div className="">

      <div className="border rounded shadow-sm">
        <DataTable
          noHeader
          highlightOnHover
          title=""
          columns={columns}
          data={data}
          pagination
          paginationServer
          paginationTotalRows={rows}
          onChangeRowsPerPage={handleItem}
          onChangePage={handleCounter}
          customStyles={customStyles}
        />
      </div>

    </div>

  </>
  )
}